import { createContext, ReactNode, useContext } from 'react';
import { DEFAULT_TOOLTIP_CONFIG, TooltipConfig } from './tooltip-model';

// TODO: cleanup TooltipConfig, make more properties required after legacy LineChartBase is removed
interface TooltipState extends TooltipConfig {}

const TooltipContext = createContext<TooltipState | undefined>(undefined);

export interface TimeSeriesTooltipProviderProps {
  tooltipConfig: TooltipConfig;
  children?: ReactNode;
}

export function TimeSeriesTooltipProvider(props: TimeSeriesTooltipProviderProps) {
  const { children, tooltipConfig } = props;
  return <TooltipContext.Provider value={tooltipConfig}>{children}</TooltipContext.Provider>;
}

export function useTooltipContext() {
  const ctx = useContext(TooltipContext);
  if (ctx === undefined) return DEFAULT_TOOLTIP_CONFIG;
  return ctx;
}
